import FiltersButton from './FiltersButton';
import './FiltersButton.scss';

export default FiltersButton;